<template>
  <div class="page-box">
    <header-bar
      :swiperActiveIndex="6"
      white
    />
    <div class="banner">
      <div>
        <div class="en">ZHANG<span>WAN</span></div>
        <div class="block">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="title2">期待与你合作</div>
      </div>
    </div>
    <p class="en">Historical Evolution</p>
    <p class="cn">合作伙伴</p>
    <div class="page-content">
      <hezuo />
    </div>
    <footer-bar />
  </div>
</template>
<script>
import Hezuo from '@/components/Hezuo'
export default {
  components: { Hezuo }
}
</script>
<style lang="scss" scoped>
.banner {
  position: relative;
  height: 100%;
  background: url(/bg/9.jpg);
  background-position: center center;
}
.en,
.cn {
  text-align: center;
}
.en {
  margin-top: 100px;
  font-size: 20px;
}
.cn {
  margin-top: 40px;
  font-size: 34px;
  margin-bottom: 90px;
}
.page-content {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto 80px;
}
.red {
  color: #f20606;
}
</style>